module.exports = __webpack_public_path__ + "static/media/promotion.b3d72466.svg";